<template>
    <pane-view :tools="tools">
        <template slot="search-pane" v-once>
            <pane-header title="Search and filter" :tools="tools"  :hasCloseSearchIcon="true" />
            <ui-scrollable-container>
                <pane-content>
                    <ui-search-field class="pane__search-bar" :tools="tools" />
                    <ui-checklist
                        title="Workflow"
                        :items="['Created', 'Awaiting review', 'Awaiting approval', 'Approved', 'Submitted']"
                    />
                    <ui-checklist
                        title="Order Status"
                        :items="['Order sent', 'Vendor confirm', 'Received', 'Routed for shelving']"
                    />
                    <ui-checklist
                        title="Payment Status"
                        :items="['No invoice', 'Created', 'Sent', 'Received', 'Approved']"
                    />
                </pane-content>
            </ui-scrollable-container>
        </template>
        <template slot="results-pane" v-once>
            <pane-header title="Orders" subtitle="86 search results" :hasSearchIcon="true" :tools="tools" appIconKey="order">
                <ui-button slot="right" title="New" iconLeft="plus" />
            </pane-header>
            <ui-scrollable-container>
                <pane-content>
                    <ui-data-list
                        preset="order"
                        type="results"
                        :tools="tools"
                        :itemCount="86"
                    />
                </pane-content>
            </ui-scrollable-container>
        </template>
        <template slot="preview-pane">
            <pane-preview-container
                :tools="tools"
            />
        </template>
    </pane-view>
</template>

<script>
    import PaneView from './PaneView';

    export default {
        name: 'order-view',
        props: ['tools'],
        components: {
            PaneView,
        },
    }
</script>



// WEBPACK FOOTER //
// OrdersView.vue?2714e7b6